export const generateNewFHIRResourceSubType = (resource) => {
    return {
        resourceId: resource._id,
        label: `${resource.label}.New-Sub-Type`,
        groupParams: resource.groupParams.reduce((map, param) => {
            map[param.param] = [{ value: `${param.param}-new-value` }];
            return map;
        }, {}),
    };
};
//# sourceMappingURL=consts.js.map